



















































import { Component, Vue, Prop } from 'vue-property-decorator';

import { curApiService, ApiService } from '@/services/ApiService';

import moment from 'moment';
import tippy from 'tippy.js';
import { FullAlert } from '@/types';

@Component({
  components:{

  }
})
export default class AlertRow extends Vue {

  @Prop({ default: () => {},  type: Object}) alert!: FullAlert;
  @Prop({ default: false,  type: Boolean}) disabled!: boolean;

  @Prop({ default: 0,  type: Number}) index!: number;
    
  async mounted() {
    tippy('[data-tippy-content]');
  }

  formatTs(ts:number|undefined): {time: string, ago: string} {

    return {
      time: ts ? moment(ts).format('L LT') : 'N/A',
      ago: ts ? moment(ts).fromNow() : 'N/A'
    };
  }

  formatName(name:string): string {
    if(name.length <= 40)
      return name;
    return name.substring(0, 40-3) + '...';
  }

  lrrRefClicked(lrrRef:string) {
    this.$router.push({name:'base-stations', params:{searchTerm:lrrRef}})
  }

  clearAlert(alertId:string) {
    this.$emit('clear-alert', alertId);
  }
}

